import { ApiClientInterface } from './clients';
import { ChangeCredential } from './models';
import { Phone } from './models';

export class ResetPasswordManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async request(phone: Phone): Promise<ChangeCredential> {
    return this.apiClient.post('request', { phone });
  }

  public async confirm(verificationCode: string, newPassword: string): Promise<void> {
    return this.apiClient.post('confirm', { verificationCode, newPassword });
  }
}
